window._mfq = window._mfq || [];
(function() {
  var mf = document.createElement("script");
  mf.type = "text/javascript"; mf.defer = true;
  mf.src = "//cdn.mouseflow.com/projects/bd33e8bf-4f45-437f-9bda-6852e34a7034.js";
  document.getElementsByTagName("head")[0].appendChild(mf);
})();
